module.exports = __webpack_public_path__ + "img/icon_calendar.3203b7e1.png";